// Şablonlar: WhatsApp Business hattındaki şablonlar (tüm durumlar). "Kullan" Mesaj Gönder'e şablonla geçer.
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { post } from '../../util/api';
import {
	Btn,
	IconBtn,
	Card,
	PageHead,
	Select,
	SearchInput,
	Segmented,
	Badge,
	Stat,
	Empty,
	Loading,
	Modal,
	ConfirmModal,
	Pager,
	COLORS,
	notify,
	num,
	paginate,
	searchMatch,
} from './ui';
import { WaFrame, TemplateBubble, comp } from './wapreview';

const PAGE_SIZE = 25;
const STATUS = {
	APPROVED: { label: 'Onaylı', tone: 'ok', group: 'approved' },
	PENDING: { label: 'İncelemede', tone: 'warn', group: 'pending' },
	IN_APPEAL: { label: 'İtirazda', tone: 'warn', group: 'pending' },
	REJECTED: { label: 'Reddedildi', tone: 'danger', group: 'archived' },
	PAUSED: { label: 'Duraklatıldı', tone: 'warn', group: 'archived' },
	DISABLED: { label: 'Devre dışı', tone: 'muted', group: 'archived' },
	ARCHIVED: { label: 'Arşiv', tone: 'muted', group: 'archived' },
};
const statusOf = (tpl) => STATUS[(tpl.status || '').toUpperCase()] || { label: tpl.status || '—', tone: 'muted', group: 'archived' };
const titleCase = (s) => (s ? s.charAt(0) + s.slice(1).toLowerCase() : '—');
const typeOf = (tpl) => {
	if (comp(tpl, 'CAROUSEL')) return 'Carousel';
	let header = comp(tpl, 'HEADER');
	let format = header && (header.format || '').toUpperCase();
	if (format === 'IMAGE') return 'Görsel';
	if (format === 'VIDEO') return 'Video';
	if (format === 'DOCUMENT') return 'Belge';
	return 'Standart';
};

class Templates extends Component {
	state = { loading: true, templates: [], phones: [], shop: '', q: '', status: 'all', category: '', language: '', page: 1 };
	componentDidMount() {
		this.getPhones();
	}
	async getPhones() {
		let { product } = this.props;
		try {
			let data = await post('/broadcast/phoneList', { pid: product.id });
			let phones = (data.data && data.data.phones) || [];
			// Editörden dönüşte ?shop=…&refresh=1: aynı hat seçili kalsın, yeni şablon görünsün diye Meta'dan yenile
			let qs = new URLSearchParams((this.props.location && this.props.location.search) || '');
			let shop = _.includes(phones, qs.get('shop')) ? qs.get('shop') : phones[0] || '';
			this.setState({ phones, shop }, () => (phones.length ? this.getTemplates(qs.get('refresh') === '1', true) : this.setState({ loading: false })));
		} catch (err) {
			this.setState({ loading: false });
			notify(this.props.t('Hatlar alınamadı.'), 'err');
		}
	}
	async getTemplates(refresh = false, silent = false) {
		let { product, t } = this.props;
		this.setState(refresh && !silent ? { refreshing: true } : { loading: true });
		try {
			let data = await post('/broadcast/templateList', { pid: product.id, shop: this.state.shop, refresh });
			let templates = _.orderBy((data.data && data.data.templates) || [], [(it) => (it.name || '').toLowerCase()]);
			this.setState({ templates, config: data.data && data.data.config, loading: false, refreshing: false, page: 1 });
			if (refresh && !silent) notify(t("Şablonlar Meta'dan yenilendi."));
		} catch (err) {
			this.setState({ loading: false, refreshing: false });
			notify(t('Şablonlar alınamadı.'), 'err');
		}
	}
	async deleteTemplate() {
		let { t } = this.props;
		let { toDelete, config } = this.state;
		this.setState({ deleting: true });
		try {
			let resp = await post('/dahi/channel/dialog360template/delete', { waba_gen_id: config.waba_gen_id, name: toDelete.name });
			if (!(resp && resp.data && resp.data.success)) throw new Error((resp && resp.data && resp.data.message) || t('Şablon silinemedi.'));
			notify(t('Şablon silindi') + ': ' + toDelete.name);
			this.setState({ toDelete: null, deleting: false });
			this.getTemplates(true, true);
		} catch (err) {
			this.setState({ deleting: false });
			notify(err.message || t('Şablon silinemedi.'), 'err');
		}
	}
	use(tpl) {
		this.props.history.push(`/wsendmessage?template=${encodeURIComponent(tpl.name)}&shop=${encodeURIComponent(this.state.shop)}`);
	}
	render() {
		let { t } = this.props;
		let { loading, refreshing, templates, phones, shop, q, status, category, language, page, config, preview } = this.state;
		let counts = _.countBy(templates, (tpl) => statusOf(tpl).group);
		let categories = _.uniq(_.compact(_.map(templates, 'category')));
		let languages = _.uniq(_.compact(_.map(templates, 'language')));
		let rows = _.filter(templates, (tpl) => {
			if (status !== 'all' && statusOf(tpl).group !== status) return false;
			if (category && tpl.category !== category) return false;
			if (language && tpl.language !== language) return false;
			let body = comp(tpl, 'BODY');
			return searchMatch(q, tpl.name, body && body.text);
		});
		let canManage = !!(config && config.waba_gen_id);
		let newLink = canManage ? `/wsendmessage/templates/new?waba_gen_id=${config.waba_gen_id}&shop=${encodeURIComponent(shop || '')}` : null;
		return (
			<div>
				<PageHead
					title={t('WABA şablonları')}
					desc={t('WhatsApp Business hattınızdaki şablonlar. Onaylı şablonlar Mesaj Gönder sekmesinde seçilebilir.')}
					right={
						<>
							{phones.length > 1 ? <Select auto value={shop} options={phones.map((p) => ({ value: p, label: p }))} onChange={(v) => this.setState({ shop: v }, () => this.getTemplates())} /> : null}
							{phones.length ? (
								<Btn variant="ghost" icon="refresh" busy={refreshing} onClick={() => this.getTemplates(true)}>
									{t("Meta'dan yenile")}
								</Btn>
							) : null}
							{newLink ? (
								<Link className="wsm-btn" to={newLink}>
									+ {t('Yeni şablon')}
								</Link>
							) : null}
						</>
					}
				/>
				{loading ? (
					<Loading />
				) : !phones.length ? (
					<Empty icon="phone" title={t('WhatsApp Business hattı bulunamadı')} desc={t('Şablonlar WhatsApp Business (360dialog) hattı bağlandığında burada listelenir.')} />
				) : (
					<>
						<div className="wsm-stats">
							<Stat label={t('Toplam')} value={num(templates.length)} active={status === 'all'} onClick={() => this.setState({ status: 'all', page: 1 })} />
							<Stat label={t('Onaylı')} value={num(counts.approved)} color={COLORS.primary} active={status === 'approved'} onClick={() => this.setState({ status: 'approved', page: 1 })} />
							<Stat label={t('İncelemede')} value={num(counts.pending)} color={COLORS.warn} active={status === 'pending'} onClick={() => this.setState({ status: 'pending', page: 1 })} />
							<Stat label={t('Arşiv / Red')} value={num(counts.archived)} color={COLORS.danger} active={status === 'archived'} onClick={() => this.setState({ status: 'archived', page: 1 })} />
						</div>
						<Card>
							<div className="wsm-section">
								<div className="wsm-row" style={{ gap: 10 }}>
									<SearchInput value={q} onChange={(v) => this.setState({ q: v, page: 1 })} placeholder={t('Şablon adı veya içerik ara…')} />
									<Segmented
										value={status}
										onChange={(v) => this.setState({ status: v, page: 1 })}
										options={[
											{ value: 'all', label: t('Tümü') },
											{ value: 'approved', label: t('Onaylı') },
											{ value: 'pending', label: t('İncelemede') },
											{ value: 'archived', label: t('Arşiv') },
										]}
									/>
									<Select
										auto
										value={category}
										options={[{ value: '', label: t('Kategori') + ': ' + t('Hepsi') }].concat(categories.map((c) => ({ value: c, label: titleCase(c) })))}
										onChange={(v) => this.setState({ category: v, page: 1 })}
									/>
									<Select
										auto
										value={language}
										options={[{ value: '', label: t('Dil') + ': ' + t('Hepsi') }].concat(languages.map((c) => ({ value: c, label: c })))}
										onChange={(v) => this.setState({ language: v, page: 1 })}
									/>
								</div>
							</div>
							<div className="wsm-table-wrap">
								<table className="wsm-table" style={{ minWidth: 820 }}>
									<thead>
										<tr>
											<th>{t('Şablon')}</th>
											<th>{t('Kategori · Tip')}</th>
											<th>{t('Önizleme')}</th>
											<th>{t('Dil')}</th>
											<th>{t('Durum')}</th>
											<th className="r">{t('İşlem')}</th>
										</tr>
									</thead>
									<tbody>
										{paginate(rows, page, PAGE_SIZE).map((tpl) => {
											let st = statusOf(tpl);
											let body = comp(tpl, 'BODY');
											return (
												<tr key={tpl.id || tpl.name + tpl.language}>
													<td className="wsm-mono" style={{ fontSize: 13, fontWeight: 600 }}>
														{tpl.name}
													</td>
													<td className="wsm-muted wsm-nowrap">
														{titleCase(tpl.category)} · {t(typeOf(tpl))}
													</td>
													<td className="wsm-muted">
														<div className="wsm-ellipsis" title={body && body.text}>
															{(body && body.text) || '—'}
														</div>
													</td>
													<td className="wsm-muted">{tpl.language || '—'}</td>
													<td>
														<Badge tone={st.tone} title={tpl.rejected_reason || undefined}>
															{t(st.label)}
														</Badge>
													</td>
													<td className="r wsm-nowrap">
														<div className="wsm-row" style={{ justifyContent: 'flex-end', gap: 6, flexWrap: 'nowrap' }}>
															{st.group === 'approved' ? (
																<button type="button" className="wsm-btn link" style={{ fontSize: 13, marginRight: 6 }} onClick={() => this.use(tpl)}>
																	{t('Kullan')}
																</button>
															) : null}
															<IconBtn icon="eye" title={t('Önizle')} onClick={() => this.setState({ preview: tpl })} />
															{canManage ? <IconBtn icon="trash" danger title={t('delete')} onClick={() => this.setState({ toDelete: tpl })} /> : null}
														</div>
													</td>
												</tr>
											);
										})}
										{!rows.length ? (
											<tr>
												<td colSpan={6} className="wsm-empty-row">
													{templates.length ? t('Filtrelerle eşleşen şablon yok.') : t("Bu hatta şablon yok. Meta'dan yenilemeyi deneyin.")}
												</td>
											</tr>
										) : null}
									</tbody>
								</table>
							</div>
							<Pager page={page} pageSize={PAGE_SIZE} total={rows.length} onChange={(p) => this.setState({ page: p })} label={`${num(rows.length)} ${t('şablon')}`} />
						</Card>
					</>
				)}
				{this.state.toDelete ? (
					<ConfirmModal
						title={t('Şablonu sil')}
						desc={this.state.toDelete.name}
						body={t('Şablon Meta hesabınızdan silinir; aynı adla 30 gün yeni şablon oluşturulamayabilir. Devam edilsin mi?')}
						confirmText={t('delete')}
						cancelText={t('Vazgeç')}
						busy={this.state.deleting}
						onClose={() => this.setState({ toDelete: null })}
						onConfirm={() => this.deleteTemplate()}
					/>
				) : null}
				{preview ? (
					<Modal
						title={preview.name}
						desc={[titleCase(preview.category), preview.language, t(statusOf(preview).label)].filter(Boolean).join(' · ')}
						icon="eye"
						width={460}
						onClose={() => this.setState({ preview: null })}
						footer={
							<>
								<Btn variant="ghost" onClick={() => this.setState({ preview: null })}>
									{t('Kapat')}
								</Btn>
								{statusOf(preview).group === 'approved' ? (
									<Btn icon="send" onClick={() => this.use(preview)}>
										{t('Kullan')}
									</Btn>
								) : null}
							</>
						}
					>
						<WaFrame>
							<TemplateBubble tpl={preview} />
						</WaFrame>
					</Modal>
				) : null}
			</div>
		);
	}
}

const stateToProps = (state) => ({ product: state.product.live });
export default connect(stateToProps)(withTranslation()(Templates));
